import { CALL_API } from '../middleware/api'

// CLIENT_COD METHOD TYPES
export const CLIENT_CODMETHODS_TYPES_REQUEST =
  'CLIENT_CODMETHODS_TYPES_REQUEST'
export const CLIENT_CODMETHODS_TYPES_SUCCESS =
  'CLIENT_CODMETHODS_TYPES_SUCCESS'
export const CLIENT_CODMETHODS_TYPES_FAILURE =
  'CLIENT_CODMETHODS_TYPES_FAILURE'

export const RESET_CODMETHODS_TYPES = 'RESET_CODMETHODS_TYPES'

export function codMethodsTypes() {
  return {
    [CALL_API]: {
      method: 'GET',
      localAPI: false,
      endpoint: 'api/admin/cod_method_types/',
      authenticated: true,
      isPublic: true,
      types: [
        CLIENT_CODMETHODS_TYPES_REQUEST,
        CLIENT_CODMETHODS_TYPES_SUCCESS,
        CLIENT_CODMETHODS_TYPES_FAILURE
      ]
    }
  }
}

export function resetCodMethods() {
  return dispatch => {
    const action = {
      type: RESET_CODMETHODS_TYPES
    }
    dispatch(action)
  }
}
